// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowSocietyActionsMenu = ({
  row,
  db_instance_id,
  onSocietyEdit,
  onSocietyDelete,
  onCreateCollege,
  onViewColleges,
  hasPermissionDirect,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_society_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onSocietyEdit(row);
            handleClose();
          }}
        >
          Edit Society
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onSocietyDelete(row.society_id);
            handleClose();
          }}
        >
          Delete Society
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateCollege(row.client_id, row.society_id, db_instance_id);
            handleClose();
          }}
        >
          Create College
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewColleges(row.client_id, row.society_id, row.society_name, db_instance_id);
            handleClose();
          }}
        >
          View Colleges
        </MenuItem>
      </Menu>
    </>
  );
};
RowSocietyActionsMenu.propTypes = {
  row: PropTypes.shape({
    client_id: PropTypes.number.isRequired,
    society_id: PropTypes.number.isRequired,
    society_name: PropTypes.string.isRequired,
    db_instance_id: PropTypes.number.isRequired,
    is_society_active: PropTypes.number.isRequired,
  }).isRequired,
  db_instance_id: PropTypes.number.isRequired,
  onSocietyEdit: PropTypes.func.isRequired,
  onSocietyDelete: PropTypes.func.isRequired,
  onCreateCollege: PropTypes.func.isRequired,
  onViewColleges: PropTypes.func.isRequired,
  hasPermissionDirect: PropTypes.func.isRequired,
};
export default RowSocietyActionsMenu;
